module.exports = __webpack_public_path__ + "static/media/tongzhi.5e2128db.jpg";